module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1052-0e622efc25b0bbb8154158deac968847.png";